import { Request } from "Utils/axiosRequest";

type GetUserRequestResponse = {
	message: string;
	data: any[];
} | {
	error: string;
};

type fetchWeatherDataResponse = WeatherReduxType[] | {
	error: string;
};

export const fetchWeatherData = async (limit?: number, offSet?: number, lastId?: number): Promise<fetchWeatherDataResponse> => {
	// const params = {
	// 	"limit": limit.toString(),
	// 	"offset": offSet.toString(),
	// 	"lastId": lastId.toString(),
	// };
	const params: Record<string, string> = {};
	if (limit) params.limit = limit.toString();
	if (offSet) params.offset = offSet.toString();
	if (lastId) params.lastId = lastId.toString();

	const response = await Request.toApi({
		url: "api/data/",
		method: "GET",
		params,
	});

	return response.map((item: any) => ({
		id: parseInt(item.id),
		// date: transformUtcToLocal(item.dateutc),
		timestamp: new Date(item.dateutc).getTime(),
		temperature: transformFToC(item.tempf),
		humidity: parseFloat(item.humidity),
		windSpeed: transformMphToKmh(item.windspeedmph),
		solarRadiation: parseFloat(item.solarradiation),
		uv: parseFloat(item.uv),
		rainRate: transformInToMm(item.rainratein),
		yearlyRain: transformInToMm(item.yearlyrainin),
		barometricPressure: transformInchesHgToHpa(item.baromrelin),
		barometricPressureAbs: transformInchesHgToHpa(item.baromabsin),
	}));
};

// const transformUtcToLocal = (date: string) => {
// 	const utcDate = new Date(date);
// 	return utcDate.toLocaleString();
// }

const transformFToC = (temp: number) => {
	return Math.round((temp - 32) * 5 / 9);
}

const transformMphToKmh = (speed: number) => {
	return Math.round(speed * 1.60934);
}

const transformInchesHgToHpa = (pressure: string) => {
	return Math.round(parseFloat(pressure) * 33.8639);
}

const transformInToMm = (rain: string) => {
	return Math.round(parseFloat(rain) * 25.4);
}

